import React from 'react';
import ProgressBar from 'components/pure/utils/ProgressBar';
import round from 'utils/round';
import './BarScore.styl';

export default class BarScore extends React.PureComponent {
  render() {
    const {score} = this.props.result;
    const label = score === null ? 'n/a' : `${round(score)}%`;
    return (
      <div className="user-bar-score score-bar-container">
        <div className="score-label">
          <span>{label}</span>
        </div>
        {score !== null && <ProgressBar percentage={score} />}
      </div>
    );
  }
}
